import { IStaticTranslationsProxy, StaticTranslation } from '@addins/core/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TranslationApiService implements TranslateLoader, IStaticTranslationsProxy {
  constructor(private readonly http: HttpClient) {}

  setup(lang: string): Observable<StaticTranslation> {
    return this.http.get<StaticTranslation>('api/Profile/GetStaticTranslations');
  }

  getTranslation(lang: string): Observable<any> {
    return this.getTranslations(lang).pipe(catchError(err => of({})));
  }

  getTranslations(lang: string): Observable<any> {
    const params = new HttpParams({ fromObject: { lang } });

    return this.http.get<string>(`api/Profile/GetMobileTranslations`, { params });
  }
}
